import { AddCircleOutlineOutlined } from '@mui/icons-material';
import { Button, type ButtonProps } from '@mui/material';
import Link from 'next/link';
import { TXM_REFERRALS_PATH } from '@/constants';

export function CreateReferralButton(props: ButtonProps) {
  return (
    <Button
      {...props}
      data-testid="CreateReferralButton"
      href={`${TXM_REFERRALS_PATH}/new`}
      LinkComponent={Link}
      size="large"
      startIcon={<AddCircleOutlineOutlined sx={{ mr: 0.5 }} />}
      variant="contained"
    >
      Create a Referral
    </Button>
  );
}
